import { render, staticRenderFns } from "./resourceSyncLog.vue?vue&type=template&id=60bc39e0&"
import script from "./resourceSyncLog.vue?vue&type=script&lang=js&"
export * from "./resourceSyncLog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports